<template>
    <div class="grid pb-3">
        <div v-for="offer in offers" class="col-12 md:col-6 lg:col-4 xl:col-3">
            <PartnerOfferCard :item="offer" />
        </div>
    </div>
</template>

<script>
import PartnerOfferCard from "./component/OfferCard.vue";

export default {
    props: {
        offers: {
            type: Array,
            required: true
        },
    },
    components: {
        PartnerOfferCard,
    },
}
</script>
